import styled, { css } from 'styled-components';
import theme from '~/styles/theme';

export const ColContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`
    
  